export default "__VITE_ASSET__CBmDyLBe__"